<template>
    <div style="margin-bottom: 10px">
        <!-- 用户消息（右侧） -->
        <div v-if="item.right" class="right">
            <div class="right_box" style="margin-top: 10px; margin-right: 10px">
                <div class="right_content_box">
                    <div v-if="item.type === 'text'" class="right_content" style="background-color: #99e3de">
                        <div>{{ item.content }}</div>
                    </div>
                    <div v-else-if="item.type === 'image'" class="right_content" style="background-color: #99e3de">
                        <van-image
                            alt="用户图片"
                            :src="item.content"
                            cross-origin="anonymous"
                            style="width: 100%; height: 100%; max-width: 200px; max-height: 200px; border-radius: 5px"
                            @error="onImageError"
                        />
                    </div>
                </div>
            </div>
            <div class="right_avatar">
                <van-image
                    round
                    alt="用户头像"
                    :src="item.avatar"
                    cross-origin="anonymous"
                    style="width: 40px; height: 40px; border-radius: 50%"
                    @error="onImageError"
                />
            </div>
        </div>

        <!-- AI 消息（居中显示） -->
        <div v-else class="w-full p-2">
            <div style="max-width: 90%">
                <div class="text-sm text-gray-400">
                    <header class="flex item-center" @click="data.isShowThinking = !data.isShowThinking">
                        {{ props.isLast && props.isThinking ? '正在思考' : '思考完成' }}
                        <svg
                            v-if="data.isShowThinking"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                            width="16"
                            height="16"
                            fill="currentColor"
                        >
                            <path
                                d="M11.9999 10.8284L7.0502 15.7782L5.63599 14.364L11.9999 8L18.3639 14.364L16.9497 15.7782L11.9999 10.8284Z"
                            ></path>
                        </svg>
                        <svg
                            v-else
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                            width="16"
                            height="16"
                            fill="currentColor"
                        >
                            <path
                                d="M11.9999 13.1714L16.9497 8.22168L18.3639 9.63589L11.9999 15.9999L5.63599 9.63589L7.0502 8.22168L11.9999 13.1714Z"
                            ></path>
                        </svg>
                    </header>
                    <main v-show="data.isShowThinking">
                        <VueMarkdownIt :source="item.think ? item.think : ''" />
                    </main>
                </div>
                <div class="w-full h-px bg-gray-400"></div>
                <VueMarkdownIt :source="item.content" />
                <!-- 加载动画 -->
                <van-loading
                    v-if="isWaiting && isLast"
                    type="spinner"
                    style="margin-top: 6px"
                    size="16"
                    color="#1989fa"
                />
            </div>
            <footer class="w-full h-4 flex px-2 gap-2">
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    width="16"
                    height="16"
                    fill="currentColor"
                    @click="copy"
                >
                    <path
                        d="M6.9998 6V3C6.9998 2.44772 7.44752 2 7.9998 2H19.9998C20.5521 2 20.9998 2.44772 20.9998 3V17C20.9998 17.5523 20.5521 18 19.9998 18H16.9998V20.9991C16.9998 21.5519 16.5499 22 15.993 22H4.00666C3.45059 22 3 21.5554 3 20.9991L3.0026 7.00087C3.0027 6.44811 3.45264 6 4.00942 6H6.9998ZM5.00242 8L5.00019 20H14.9998V8H5.00242ZM8.9998 6H16.9998V16H18.9998V4H8.9998V6Z"
                    ></path>
                </svg>
                <svg
                    v-if="userInfo?.userType === 'admin'"
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    width="16"
                    height="16"
                    fill="currentColor"
                    @click="emit('edit')"
                >
                    <path
                        d="M16.7574 2.99678L14.7574 4.99678H5V18.9968H19V9.23943L21 7.23943V19.9968C21 20.5491 20.5523 20.9968 20 20.9968H4C3.44772 20.9968 3 20.5491 3 19.9968V3.99678C3 3.4445 3.44772 2.99678 4 2.99678H16.7574ZM20.4853 2.09729L21.8995 3.5115L12.7071 12.7039L11.2954 12.7064L11.2929 11.2897L20.4853 2.09729Z"
                    ></path>
                </svg>
            </footer>
        </div>
    </div>
</template>

<script setup lang="ts">
import VueMarkdownIt from 'vue3-markdown-it';
import { reactive } from 'vue';
import { showToast } from 'vant';
import { getUserInfoFromStorage } from '../utils/storage';

const props = defineProps<{
    item: { content: string; avatar: string; right: boolean; think?: string; type: string };
    index: number;
    isWaiting: boolean;
    isLast: boolean; // 父组件中判断 index === messageList.length - 1 后传入
    isThinking: boolean;
}>();
const emit = defineEmits(['edit']);
const userInfo = getUserInfoFromStorage();
const data = reactive({
    isShowThinking: true,
});
function onImageError(event: Event) {
    const target = event.target as HTMLImageElement | null;
    if (target) {
        // 如果图片加载失败，设置默认图片
        target.src = 'logo.png';
    }
}
const copy = () => {
    const text = props.item.content;
    navigator.clipboard
        .writeText(text)
        .then(() => {
            showToast('复制成功');
        })
        .catch(err => {
            showToast('复制失败');
        });
};
</script>

<style scoped>
.right {
    display: flex;
    justify-content: flex-end;
}

.right_content_box {
    /* width: 80%; */
    display: flex;
    align-items: flex-end;
}

.right_content {
    word-wrap: break-word;
    word-break: break-all;
    font-size: 14px;
    text-align: left;
    /* background-color: #e5e5e5; */
    border-radius: 5px;
    padding: 10px 10px;
    margin-left: 5px;
    max-width: 200px;
    letter-spacing: 1px;
    font-family: Arial, Helvetica, sans-serif;
}

.right_avatar {
    margin-right: 10px;
    margin-top: 5px;
}

.left {
    display: flex;
    justify-content: flex-start;
}

.left_box {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    margin-left: 5px;
}

.left_content_box {
    /* width: 80%; */
    display: flex;
    align-items: flex-end;
}

.left_content {
    word-wrap: break-word;
    word-break: break-all;
    font-size: 14px;
    text-align: left;
    /* background-color: #99e3de; */
    border-radius: 5px;
    padding: 10px 10px;
    margin-right: 5px;
    max-width: 200px;
    letter-spacing: 1px;
    font-family: Arial, Helvetica, sans-serif;
}

.left_avatar {
    margin-left: 10px;
    margin-top: 5px;
}
</style>
